import React from "react";
import Accordion from '@visa/vds/accordion';
import AccordionBody from '@visa/vds/accordion-body';
import AccordionItem from '@visa/vds/accordion-item';
import AccordionHeading from '@visa/vds/accordion-heading';
import AccordionTitle from '@visa/vds/accordion-title';
import OrderReferenceAccordionBody from './OrderReferenceAccordionBody';

const OrderReferenceAccordion = (props) => {
    return (
        <Accordion id="accordion-order-reference">
            <AccordionItem>
                <AccordionHeading>
                    <AccordionTitle>
                        Order Reference
                    </AccordionTitle>
                </AccordionHeading>
                <AccordionBody>
                    <OrderReferenceAccordionBody order={props.order}
                        showOrderNotes={props.showOrderNotes}
                    />
                </AccordionBody>
            </AccordionItem>
        </Accordion>
    );
}
export default OrderReferenceAccordion;